import React, { useEffect, useState } from "react";
import { setCreateAccount, setEmailError } from "../../redux/Slices/loginSlice";
import CustomTextField from "../../components/ReUsableComponents/CustomTextField";
import { clearStore, getItem, setItem } from "../../utils/token";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { useSignInMutation, useUpdateDeviceDataMutation } from "../../redux/API/Login/loginApi";
import { RootState } from "../../redux/Store/store";
import { useNavigate } from "react-router-dom";
import { RiEyeCloseLine } from "react-icons/ri";
import { LuUser } from "react-icons/lu";
import workingWomen from "../../assets/Images/working-women.svg";
import { FcGoogle } from "react-icons/fc";

import { IoWarningOutline } from "react-icons/io5";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { GrCircleAlert } from "react-icons/gr";
import AuthButton from "./LoginButton";
import { appleClientId, appleUrl, googleUrl } from "../../apiConfig";
import AppleLogin from "react-apple-login";
import { BsApple } from "react-icons/bs";
import logoNew from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";
import OnboardingBackground from "../../components/ReUsableComponents/OnboardingBackground";
function LoginV1() {
  const emailPattern = /^[a-zA-Z0-9][^\s@]*@[^\s@]+\.[a-zA-Z]+$/;
  const [userSignInData, setUserSignInData] = useState({
    userName: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [signIn, { isLoading: signInLoading }] = useSignInMutation();
  const [updateDeviceData] = useUpdateDeviceDataMutation();
  const { emailError } = useSelector(
    (state: RootState) => state.root.loginSlice
  );
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  const handleChangeSignIn = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setEmailError(""));
    setError("");
    setUserSignInData((prevState) => ({
      ...prevState,
      [name]: value?.trim(),
    }));
  };

  const validateEmail = (email: string) => {
    if (!emailPattern.test(email)) {
      dispatch(setEmailError("PLEASE SIGN IN WITH A VALID EMAIL"));
      return false;
    }
    return true;
  };

  const handleSuccess = async (response: any) => {
    if (response.isFirstTimeLogin) {
      navigate("/profilesetup");
    }
    const { token, isLogin, refreshToken, route } = response;
    setItem("isLogin", isLogin);
    if (token) {
      setItem("token", token);
      setItem("refreshToken", refreshToken);
      const decoded: any = jwtDecode(token);
      setItem("userName", decoded?.firstName);
      setItem("userRole", decoded?.role ?? null);
      setItem("userEmail", decoded?.userEmail);
      setItem("userId",decoded?.id);
      const expiryTime = decoded.exp;
      if (decoded.role && !route) {
        decoded.role === "PARENT"
          ? navigate("/parentdashboard")
          : navigate("/dashboard");
      } else if (decoded.role === "PARENT" && route) {
        navigate(route);
      } else if (decoded.role === "STUDENT" && route) {
        navigate(route);
      }
      if (expiryTime) {
        setItem("expiryTime", expiryTime.toString());
      }
      let payload = collectData();
      await updateDeviceData(payload);
    }
  };

  const handleError = (error: any) => {
    if (error.status === 401) {
      setError("Your email or password is wrong. Please try again");
    } else {
      setError(error?.data?.message);
    }
  };

  const handleGoogleSignIn = () => {
    window.open(googleUrl, "_self");
  };

  const handleLogIn = async () => {
    if (!validateEmail(userSignInData.userName)) {
      return;
    }
    try {
      const route = getItem("route");
      const payload = {
        ...userSignInData,
        userName: userSignInData?.userName?.trim()?.toLowerCase(),
        route,
      };
      const res: any = await signIn(payload).unwrap();
      if (res.isLogin) {
        handleSuccess(res);
      } else {
        setError(res?.message);
      }
    } catch (error: any) {
      handleError(error);
    }
  };
  
  const collectData = () => {

    const getDevice = () =>{
      const userAgent = navigator.userAgent;

      if (/Mobi|Android/i.test(userAgent)) {
        return "Mobile";
      } else if (/Tablet|iPad/i.test(userAgent)) {
        return "Tablet";
      } else {
        return "Desktop";
      }
    }

    const getOS = () => {
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.platform;
    
      if (/Win/i.test(platform)) return "Windows";
      if (/Mac/i.test(platform)) return "MacOS";
      if (/Linux/i.test(platform)) return "Linux";
      if (/Android/i.test(userAgent)) return "Android";
      if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
    
      return "Unknown";
    };

    const getFormattedTimeDifference = () => {
      const offset = -new Date().getTimezoneOffset();
      const sign = offset >= 0 ? "+" : "-";
      const absOffset = Math.abs(offset);
      const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
      const minutes = String(absOffset % 60).padStart(2, "0");
      return `${sign}${hours}:${minutes}`;
    };

    return {
      os: getOS(),
      device: getDevice(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timeDifference: getFormattedTimeDifference(),
    };
  };

  useEffect(() => {
    let route = getItem("route");
    if (route) {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key !== 'route') {
          localStorage.removeItem(key);
        }
      }
    } else {
      localStorage.clear();
    }
    setItem("token", "");
    setItem('clientData',JSON.stringify(collectData()));
  }, []);

  useEffect(() => {
    if (userSignInData?.userName && userSignInData?.password) {
      const handleKeyPress = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
          handleLogIn();
        }
      };
      window.addEventListener("keydown", handleKeyPress);

      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [userSignInData]);

  return (
    <OnboardingBackground>
      <div className="flex flex-col items-center w-[720px] px-6 pt-6 pb-9 rounded-2xl shadow-lg border border-satPrepGrey backdrop-blur-one bg-satPrepTransWhite mx-auto my-10">
        <div>
          <img src={logoNew} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
          <img src={sat} className="w-[211px] h-[68px] mx-auto" alt="SATprep Logo" />
        </div>
        <div className="w-full">
          <div className="flex-col justify-center items-center gap-x-2 mb-9"></div>{" "}
            <div className="flex justify-center items-center flex-col w-full">
              <div className="w-[450px]">
               {emailError && (
                  <div className="flex items-center gap-x-1  pb-3">
                   <IoWarningOutline size={14} className="text-satPrepRed" />
                   <p className="text-satPrepRed text-xs font-semibold">
                    {emailError}
                  </p>
                </div>
              )}
              {error && (
                <div className="inline-flex items-center gap-x-2.5 h-[47px] py-[23px] px-[10px] mb-9 border border-satPrepRed bg-satPrepTransWhite rounded-xl backdrop-blur-sevenFive shadow-error-screen w-auto max-w-full">
                  <div>
                    <GrCircleAlert
                      size={24}
                      className="text-satPrepRed mr-[10px]"
                    />
                  </div>
                  <p className="text-satPrepRed text-base font-semibold whitespace-pre-wrap">
                    {error}
                  </p>
                </div>
              )}
            </div>
            <div>
              <CustomTextField
                onChangeHandler={handleChangeSignIn}
                placeholder="Email "
                type="text"
                name="userName"
                mandatory={true}
                value={userSignInData?.userName?.trim()}
                className="md:!w-[446px] w-full !border-[#646464]"
                isError={emailError !== ""}
                containerClass="mb-3"
              />
            </div>
            <div className="flex justify-between relative">
              <CustomTextField
                onChangeHandler={handleChangeSignIn}
                placeholder="Password"
                type={`${showPassword ? "text" : "password"}`}
                name="password"
                mandatory={true}
                value={userSignInData?.password?.trim()}
                className="md:!w-[446px] w-full !border-[#646464]"
              />
              {userSignInData.password && (
                <button
                  className="absolute right-6 bottom-3 cursor-pointer text-2xl text-[#646464]"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <MdOutlineRemoveRedEye />
                  ) : (
                    <RiEyeCloseLine />
                  )}
                </button>
              )}
            </div>
          </div>
          <div className="my-6 flex justify-center">
            <AuthButton
              text="Sign In"
              icon={<LuUser />}
              iconPosition="left"
              onClick={handleLogIn}
              loader={signInLoading}
              disabled={
                signInLoading ||
                !userSignInData.userName ||
                !userSignInData.password
              }
            />
          </div>
          <div className="flex flex-col gap-6">
            <div className="flex justify-center items-center gap-[6px]">
              <div className="w-20 h-[2px] bg-[#646464]"></div>
              <p className="text-center font-gully text-[16px] text-[#646464]">
                or
              </p>
              <div className="w-20 h-[2px] bg-[#646464]"></div>
            </div>

            <div className="flex gap-3 justify-center items-center">
              <AppleLogin
                clientId={appleClientId}
                scope={"name email"}
                redirectURI={appleUrl}
                responseType={"code id_token"}
                responseMode={"form_post"}
                render={(renderProps) => (
                  <button
                    onClick={renderProps.onClick}
                    className="flex px-[34px] py-[14px] justify-center items-center rounded-xl border border-satPrepAccent bg-satPrepWhite"
                  >
                    <BsApple size={24} />
                  </button>
                )}
                usePopup={false}
              />
              <button
                className="flex px-[34px] py-[14px] justify-center items-center rounded-xl border border-satPrepAccent bg-satPrepWhite"
                onClick={handleGoogleSignIn}
              >
                <FcGoogle size={24} />
              </button>
            </div>
          </div>
          <div className="flex justify-center items-center mt-9 gap-x-1 whitespace-nowrap">
            <p className="text-satPrepBlack">Need an account? </p>
            <button
              className="underline text-satPrepDarkAccent flex justify-center text-base mr-6 cursor-pointer"
              onClick={() => {
                navigate("/socialsignup");
                dispatch(setCreateAccount(true));
                setError("");
                dispatch(setEmailError(""));
                setUserSignInData({
                  userName: "",
                  password: "",
                });
              }}
            >
              Sign up!
            </button>
            <p>
              Help with password?{" "}
              <button
                onClick={() => navigate("/forgotPassword")}
                className="underline text-satPrepDarkAccent cursor-pointer"
              >
                Help is here!
              </button>{" "}
            </p>
          </div>
        </div>
      </div>
    </OnboardingBackground>
  );
}

export default LoginV1;
